/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Icon from "../../Icon";
import { ReschduleIcon } from "icons";
import useStyles from "../style";
import { getStatusColor } from "../util";
import IconComponent from "components/IconComponent";
export const MenuList = React.memo(
  ({
    eventItem,
    status,
    btnText,
    onEditClickedCallback,
    onDuplicateClickedCallback,
    onPreviewClickedCallback,
    onArchiveClickedCallback,
    onCancelClickedCallback,
    onScheduleInviteClickedCallback,
    onRescheduleClickedCallback,
    upcoming,
  }) => {
    const classes = useStyles({ status, getStatusColor });
    const [menuanchorEl, setMenuAnchorEl] = useState(null);
    const openMenu = (event) => {
      setMenuAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
      setMenuAnchorEl(null);
    };
    return (
      <>
        {status.toLowerCase() !== "archived" ? (
          <IconButton
            aria-label="more"
            aria-haspopup="true"
            aria-controls="simple-menu"
            onClick={openMenu}
            classes={Boolean(menuanchorEl) ? { label: classes.menuIconButton } : {}}
          >
            <MoreVertIcon className={classes.menuicon} />
          </IconButton>
        ) : (
          <div className={classes.noContext} />
        )}
        <Menu
          id="simple-menu"
          anchorEl={menuanchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          open={Boolean(menuanchorEl)}
          onClose={closeMenu}
          classes={{
            paper: classes.menuroot,
          }}
        >
          {btnText.toLowerCase() !== "schedule invite" && status === "published" && (
            <MenuItem
              onClick={() => onScheduleInviteClickedCallback(eventItem)}
              ListItemClasses={{
                button: classes.listbtn,
              }}
            >
              <ListItemIcon
                button="false"
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-event-confirm" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Schedule Invite
              </Typography>
            </MenuItem>
          )}
          {/* Edit Button */}
          {btnText.toLowerCase() !== "edit" && status !== "canceled" && (
            <MenuItem
              onClick={() => onEditClickedCallback(eventItem)}
              ListItemClasses={{
                button: classes.listbtn,
              }}
            >
              <ListItemIcon
                button="false"
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-pencil" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Edit
              </Typography>
            </MenuItem>
          )}
          {/* Preview Button */}
          {status !== "canceled" && (
            <MenuItem
              onClick={() => onPreviewClickedCallback(eventItem)}
              ListItemClasses={{
                button: classes.listbtn,
              }}
            >
              <ListItemIcon
                button="false"
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-preview" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Preview
              </Typography>
            </MenuItem>
          )}
          {/* Duplicate Button */}
          {status !== "canceled" && (
            <MenuItem
              onClick={() => {
                closeMenu();
                onDuplicateClickedCallback(eventItem);
              }}
              ListItemClasses={{
                button: classes.listbtn,
              }}
            >
              <ListItemIcon
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-single-copy-04" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Duplicate
              </Typography>
            </MenuItem>
          )}
          {/* Duplicate Button */}
          {(status === "published" || status === "invite_scheduled" || status === "invited") &&
            upcoming && (
              <MenuItem
                onClick={() => {
                  closeMenu();
                  onRescheduleClickedCallback(eventItem);
                }}
                ListItemClasses={{
                  button: classes.listbtn,
                }}
              >
                <ListItemIcon
                  classes={{
                    root: classes.iconroot,
                  }}
                >
                  <IconComponent Component={ReschduleIcon} />
                </ListItemIcon>
                <Typography className={classes.menutext} variant="body1">
                  Reschedule Event
                </Typography>
              </MenuItem>
            )}

          {/* Archive Button / Cancel Button */}
          {status === "published" ||
            status === "invited" ||
            status.toLowerCase() === "scheduled for invite" ? (
            <MenuItem
              onClick={() => {
                closeMenu();
                onCancelClickedCallback(eventItem);
              }}
              ListItemClasses={{
                button: classes.listbtnred,
              }}
            >
              <ListItemIcon
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-c-remove" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Cancel Event
              </Typography>
            </MenuItem>
          ) : (
            <MenuItem
              onClick={() => {
                closeMenu();
                onArchiveClickedCallback(eventItem);
              }}
              ListItemClasses={{
                button: classes.listbtn,
              }}
            >
              <ListItemIcon
                classes={{
                  root: classes.iconroot,
                }}
              >
                <Icon type="icon-todo" size="md" className={classes.normico} />
              </ListItemIcon>
              <Typography className={classes.menutext} variant="body1">
                Archive
              </Typography>
            </MenuItem>
          )}
        </Menu>
      </>
    );
  }
);
export const PreviewIcon = React.memo(({ stroke, fill }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.875 10.2084C1.875 10.2084 5.16667 5.20839 10.2083 5.20839C15.2083 5.20839 18.5417 10.2084 18.5417 10.2084C18.5417 10.2084 15.1667 15.2084 10.2083 15.2084C5.20833 15.2084 1.875 10.2084 1.875 10.2084Z"
      stroke="#333333"
      strokeMiterLimit="10"
      strokeLinecap="square"
    />
    <path
      d="M10.2083 11.8751C12.0493 11.8751 13.5417 10.3827 13.5417 8.54172C13.5417 6.70077 12.0493 5.20839 10.2083 5.20839C8.36738 5.20839 6.875 6.70077 6.875 8.54172C6.875 10.3827 8.36738 11.8751 10.2083 11.8751Z"
      stroke="#333333"
      strokeMiterLimit="10"
      strokeLinecap="square"
    />
  </svg>
));
export const RenderToolTip = React.memo(({ status, eventItem }) => {
  const classes = useStyles({ status, getStatusColor });
  const title = toolTipTitle(status.toLowerCase(), eventItem);
  if (title === "") {
    return (
      <Typography className={classes.status} variant="body1">
        {status}
      </Typography>
    );
  } else {
    return (
      <Tooltip title={title} aria-label="add" arrow>
        <Typography className={classes.status} variant="body1">
          {status}
        </Typography>
      </Tooltip>
    );
  }
});
const toolTipTitle = (status, eventItem) => {
  switch (status) {
    case "scheduled for publish":
      return `Scheduled to publish at: ${eventItem.publishAt}`;
      break;
    case "scheduled for invite":
      return `Scheduled to send invites at: ${eventItem.inviteScheduledAt}`;
      break;
    default:
      return "";
  }
};